import { render, staticRenderFns } from "./CustomerViewLayout.vue?vue&type=template&id=4e149411&scoped=true&lang=pug&"
import script from "./CustomerViewLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerViewLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerViewLayout.vue?vue&type=style&index=0&id=4e149411&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e149411",
  null
  
)

export default component.exports